import * as THREE from 'three'

/**
 * Composites the processed car (from dither shader) on top of
 * the clean background scene using the model mask.
 * Applies exposure + ACES tone-mapping to the raw linear background
 * so it matches the already-tone-mapped car output.
 */
export const CompositeShader = {
    name: 'CompositeShader',
    uniforms: {
        tBackground: { value: null },  // clean scene (bg + ground planes) — raw linear
        tProcessed: { value: null },   // dither-processed car — already tone-mapped
        tMask: { value: null },        // model mask (white = car)
        uExposure: { value: 1.0 },
    },
    vertexShader: /* glsl */`
        varying vec2 vUv;
        void main() {
            vUv = uv;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        }
    `,
    fragmentShader: /* glsl */`
        uniform sampler2D tBackground;
        uniform sampler2D tProcessed;
        uniform sampler2D tMask;
        uniform float uExposure;
        varying vec2 vUv;

        vec3 ACESFilm(vec3 x) {
            float a = 2.51;
            float b = 0.03;
            float c = 2.43;
            float d = 0.59;
            float e = 0.14;
            return clamp((x*(a*x+b))/(x*(c*x+d)+e), 0.0, 1.0);
        }

        void main() {
            vec3 bg = texture2D(tBackground, vUv).rgb;
            bg *= uExposure;
            bg = ACESFilm(bg);
            bg = pow(bg, vec3(1.0 / 2.2));

            vec3 car = texture2D(tProcessed, vUv).rgb;
            float mask = texture2D(tMask, vUv).r;
            gl_FragColor = vec4(mix(bg, car, mask), 1.0);
        }
    `,
}
